// extracted by mini-css-extract-plugin
export default {"statistics-container-vicri":"CitiesViCRIBlock_statistics-container-vicri__eI0qe"};